import { render, staticRenderFns } from "./SaiDaoAgreement.vue?vue&type=template&id=1110bfae&"
import script from "./SaiDaoAgreement.vue?vue&type=script&lang=js&"
export * from "./SaiDaoAgreement.vue?vue&type=script&lang=js&"
import style0 from "./SaiDaoAgreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports